export default __webpack_public_path__ + "static/media/auth-img.b3fc6412.png";